import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import FilterBtn from "../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../Assets/Icons/btn-filters-up.png";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";
import CustomLoadingOverlay from "../../../Components/CustomLoadingOverlay";
import { createFilterHandler } from "../../../Utils/FilterUtils";
import httpclient from "../../../Utils";

import { getColumns } from "./columns";
import Filter from "./Filter";
import { useFakeCustomer } from "./useFakeCustomer";
import ConfirmationDialog from "./ConfirmationDialog";

const INITIAL_FILTER_STATE = {
  customerNo: "",
  customerName: "",
  createdDate: "",
  createdBy: "",
};

const fieldMappings = {
  customerNo: ["customer_no", "$eq"],
};

export default function FakeCustomer() {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const [openDeleteCustomer, setOpenDeleteCustomer] = useState(false);
  const [isDeletingCustomer, setIsDeletingCustomer] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [sortModel, setSortModel] = useState([]);

  const navigate = useNavigate();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();

  const {
    fakeCustomers,
    setFakeCustomers,
    loading,
    setLoading,
    rowCount,
    refresh,
    refreshFakeCustomers,
    allowAdd
  } = useFakeCustomer({
    
    autoFetch: true,
    pagination: {
      page: paginationModel.page, // Pass primitive values
      pageSize: paginationModel.pageSize,
    },
    sorting: sortModel,
  });
console.log("allowadd", allowAdd)
  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: setFakeCustomers,
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: `/fake-customer`,
    fieldMappings,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] = ""; // Reset other fields to empty string;

    delete newSubmittedData[field];
    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    handleFilter(INITIAL_FILTER_STATE);
  };

  const handleAddCustomer = () => {
    navigate("/fake-customer/add");
  };

  const handleDeleteCustomer = async () => {
    setIsDeletingCustomer(true);

    const API_URL = `/fake-customer/${selectedCustomer.id}`;

    try {
      const { data } = await httpclient.delete(API_URL);
      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedCustomer("");
        setOpenDeleteCustomer(false);
        refreshFakeCustomers(true);
      } else {
        showNotification("info", data.message);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setTimeout(() => {
          setOpenDeleteCustomer(false); // Close modal
        }, 1000);
      } else if (error.response?.status === 401) {
        refresh();
      }
      handleApiError(error);
    } finally {
      setIsDeletingCustomer(false);
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const columns = getColumns(setSelectedCustomer, setOpenDeleteCustomer);

  const deleteUserMessage = (
    <>
      Are you sure you want to delete{" "}
      <strong>{selectedCustomer?.customer_name}</strong>?
    </>
  );

  return (
    <>
      <Box sx={{ width: "100%", padding: 2 }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            backgroundColor: "#fff",
            padding: "24px 16px",
            borderRadius: "8px",
          }}
        >
         
              
            
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Fake Customer
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >

              {
                allowAdd?.allow_add === 1 && (

               
              <Button
                variant="contained"
                size="large"
                sx={{
                  borderRadius: "4px",
                  marginRight: "16px",
                  backgroundColor: "#7152F3",
                  "&:hover": {
                    backgroundColor: "#5c34fa",
                  },
                }}
                startIcon={<AddIcon sx={{ marginRight: 0 }} />}
                onClick={handleAddCustomer}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Add New Customer
                </Typography>
              </Button>
               )
              }
              <img
                src={filterOpen ? FilterBtnUp : FilterBtn}
                alt="Filter"
                style={{ cursor: "pointer" }}
                onClick={() => setFilterOpen(!filterOpen)}
              />
              
            </Box>
            
          </Box>
         

          <Filter
            filterOpen={filterOpen}
            filterData={filterData}
            handleChangeFilter={handleChangeFilter}
            handleFilter={onFilterClick}
            handleClearFilters={handleClearFilters}
            handleRemove={handleRemove}
            submittedData={submittedData}
            fakeCustomers={fakeCustomers}
          />

          <DataGrid
            rows={fakeCustomers || []}
            columns={columns}
            autoHeight
            disableRowSelectionOnClick
            loading={loading}
            slots={{
              loadingOverlay: CustomLoadingOverlay,
            }}
            sx={{
              "& .MuiDataGrid-cell": {
                fontSize: "14px",
                fontWeight: 500,
                color: "#48505E",
              },
            }}
            paginationMode="server"
            sortingMode="server"
            onSortModelChange={handleSortModelChange}
            sortModel={sortModel}
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[20, 50, 100]}
          />
        </Box>
      </Box>
      {openDeleteCustomer && (
        <ConfirmationDialog
          open={openDeleteCustomer}
          handleClose={() => setOpenDeleteCustomer(false)}
          title={"Delete Customer"}
          message={deleteUserMessage}
          selectedUser={selectedCustomer}
          onConfirm={handleDeleteCustomer}
          loading={isDeletingCustomer}
        />
      )}
    </>
  );
}
